// Central place for feature toggles.
//
// SPIN_WHEEL_COMING_SOON:
//   - true  -> users only see a blocking "Coming soon" modal on the Spin Wheel
//              page and cannot interact with the feature. Ship this to users.
//   - false -> the Spin Wheel feature is fully interactive. Use this while you
//              keep building and testing the feature.
//
// You can flip it here in code, or override it at build time with the env var
// REACT_APP_SPIN_WHEEL_COMING_SOON ("true" / "false") without touching code.

const parseBooleanEnv = (value, fallback) => {
  if (value === undefined || value === null || value === '') {
    return fallback;
  }

  return value.toLowerCase() === 'true';
};

// Default: show "Coming soon" to users.
export const SPIN_WHEEL_COMING_SOON = parseBooleanEnv(process.env.REACT_APP_SPIN_WHEEL_COMING_SOON, true);
